import { createFilledIcon } from "../createIcon";

export const SettingsFilledIcon = createFilledIcon(
  <>
    <path d="M13.863 3.463c-.476-1.95-3.25-1.95-3.726 0A1.915 1.915 0 0 1 7.28 4.648c-1.715-1.045-3.678.917-2.633 2.632a1.916 1.916 0 0 1-1.184 2.859c-1.95.474-1.95 3.25 0 3.722a1.915 1.915 0 0 1 1.184 2.86c-1.045 1.714.918 3.677 2.633 2.632a1.915 1.915 0 0 1 2.859 1.183c.474 1.952 3.25 1.952 3.722 0a1.917 1.917 0 0 1 2.86-1.183c1.714 1.045 3.677-.918 2.632-2.633a1.916 1.916 0 0 1 1.183-2.859c1.952-.473 1.952-3.25 0-3.722a1.915 1.915 0 0 1-1.183-2.859c1.045-1.715-.918-3.677-2.633-2.632a1.915 1.915 0 0 1-2.859-1.184l.002-.001ZM12 15.75a3.75 3.75 0 1 0 0-7.5 3.75 3.75 0 0 0 0 7.5Z" />
  </>,
  "SettingsFilledIcon"
);
